import { Row, Col, Typography, Breadcrumb, Button, message } from 'antd';
import { CiExport } from "react-icons/ci";
import { useCookies } from 'react-cookie';
import { exportToExcel } from '../utils/exportToExcel';
import { getUserStatsUrl } from '../constants';
import axios from 'axios';

const { Title } = Typography;

const PageHeader = ({ title, breadcrumbItems }) => {
    const [cookies] = useCookies();

    const handleExportStats = async () => {
        try {
            const response = await axios.get(`${getUserStatsUrl}/${localStorage.getItem("clientId")}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("token")}`
                }
            });

            exportToExcel(response.data.data);
            message.success('Statistiques exportées avec succès');
        } catch (error) {
            console.error('Error exporting statistics:', error);
            message.error('Erreur lors de l\'exportation des statistiques');
        }
    };

    return (
        <div
            style={{
                background: "white",
                minHeight: 100,
                width: "100%",
                boxShadow: "inset 10px 3px 10px -10px #00000055"
            }}
        >
            <Row style={{ padding: "16px 0px 24px 24px", width: "100%" }} align="middle">
                <Col span={16}>
                    <Breadcrumb style={{ margin: "16px 0", fontSize: "14px" }}>
                        {breadcrumbItems.map((item, index) =>
                            <Breadcrumb.Item key={index}>{item}</Breadcrumb.Item>
                        )}
                    </Breadcrumb>
                    <Title level={4} style={{ margin: 0 }}>{title}</Title>
                </Col>

                <Col span={8} style={{ display: "flex", justifyContent: "flex-end", paddingRight: 24 }}>
                    <Button
                        style={{ color: "#fff", backgroundColor: "#39B13D", border: "none", display: "flex", alignItems: "center", gap: "12px" }}
                        onClick={handleExportStats}
                    >
                        <CiExport />
                        <span>Exporter les statistiques des utilisateurs</span>
                    </Button>
                </Col>
            </Row>

        </div>
    );
}

export default PageHeader;